export function register(config) {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL}/serviceWorker.js`;
  
        navigator.serviceWorker.register(swUrl, config)
          .then((registration) => {
            console.log('SW registered: ', registration);
          })
          .catch((error) => {
            console.error('SW registration failed: ', error);
          });
      });
    }
  }
  
  export function unregister() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.unregister();
      });
    }
  }
  